import React from 'react';
import { Box } from '@mui/material';
import { ReactComponent as LogoMark } from 'assets/icons/home/hmCoreLogo.svg';
import classes from './Loader.module.scss';


// Тот же знак, что и в стартовом прелоадере (public/index.html), — переход между ними незаметен.
const Loader = () => {
  return (
    <Box className={classes.loaderBlock} role="status" aria-label="Загрузка">
      <span className={classes.mark}>
        <span className={classes.glow} />
        <LogoMark className={classes.base} aria-hidden />
        <LogoMark className={classes.fill} aria-hidden />
      </span>
    </Box>
  );
};

export default Loader;
